import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {LogsService} from '../../../../core/services/logs.service';
import {fuseAnimations} from '../../../../core/animations';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import { fromEvent as observableFromEvent} from 'rxjs';

@Component({
    selector: 'logs-history',
    templateUrl: './logs.component.html',
    styleUrls: ['./logs.component.scss'],
    animations: fuseAnimations,
    standalone: false
})

export class LogsComponent implements OnInit{
  @ViewChild('filter', {static: true}) filter: ElementRef;
  dataSource;
  displayedColumns: string[] = ['user', 'login', 'logout', 'time'];
  pageSize = 10;
  pageIndex = 0;
  totalCount;
  search = '';
  _sort = 'login';
  _direction = 'desc';

  constructor(public logService: LogsService) {

  }

  ngOnInit() {
    observableFromEvent(this.filter.nativeElement, 'keyup').pipe(
      debounceTime(800),
      distinctUntilChanged())
      .subscribe(() => {
        if (this.filter.nativeElement.value && this.filter.nativeElement.value.replace(/ /g, '')
          && this.filter.nativeElement.value !== null && this.filter.nativeElement.value !== 'null') {
          this.search = this.filter.nativeElement.value;
          this.pageIndex = 0;
          this.getLogs();
        } else if ((!this.filter.nativeElement.value || this.filter.nativeElement.value === '') && this.search) {
          this.search = '';
          this.pageIndex = 0;
          this.getLogs();
        }
      });
    this.getLogs();
  }

  getLogs() {
    this.logService.getLogs(this.pageIndex + 1, this.pageSize, this.search, this._sort, this._direction).subscribe((res: any) => {
      if (res && res.logs) {
        this.dataSource = res.logs.map((el) => {
          if (el.login && el.logout) {
            let time = (new Date(el.logout)).getTime() - (new Date(el.login)).getTime();
            let  minutes: any = Math.floor((time / (1000 * 60)) % 60);
            let  hours: any = Math.floor((time / (1000 * 60 * 60)) % 24);
            hours = (hours < 10) ? '0' + hours : hours;
            minutes = (minutes < 10) ? '0' + minutes : minutes;
            el.time = hours + ':' + minutes;
          }
          return el;
        });
        this.totalCount = res.total;
      } else {
        this.dataSource = [];
        this.totalCount = 0;
      }
    });
  }

  changePageEmitter(e) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.getLogs();
  }

  sortData(e) {
    this._sort = e.active;
    this._direction = e.direction;
    if (!e.direction) {
      this._sort = 'login';
      this._direction = 'desc';
    }
    this.getLogs();
  }

}
